import ReactDOM from "react-dom/client";
import "./index.css";
import appRouter from "./utils/appRouter.jsx";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./utils/store";

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <RouterProvider router={appRouter} />
  </Provider>
);
